declare module '#app' {
  interface NuxtApp {
    $easyApi: typeof $fetch
  }
}

export default defineNuxtPlugin(() => {
  const { app } = useRuntimeConfig()
  const easyApi = $fetch.create({
    baseURL: `${app.baseURL}/api/easyApi`,
    onRequest({ options }) {
      const token = useUserStore().accessToken
      if (!token) {
        options.signal = AbortSignal.abort()
        return
      }
      const headers = new Headers(options.headers)
      headers.set('Authorization', `Bearer ${token}`)
      options.headers = headers
    },
  })
  return {
    provide: {
      easyApi,
    },
  }
})
